<template>
    <div class="tep-nagr-system-wrap">
        <div class="tep-nagr-system-title">
            {{ meta.metaScheme.title }}
        </div>
        <div class='tep-nagr-system-container'>
            <div class='tep-nagr-system-grid'>
                <dx-button hint="Выбрать схему" width='32px' height='32px' @click="openNsi">
                    <img :src="'/infoenergo/assets/tep/tep-cards/arrow-right.svg'" alt='' class='w-full h-full'>
                </dx-button>
                <dx-button hint="Удалить схему" width='32px' height='32px' @click="deleteScheme">
                    <img :src="'/infoenergo/assets/tep/tep-cards/delete.svg'" alt='' class='w-full h-full'>
                </dx-button>
                <ai-form-text-box-readonly
                    class="tep-nagr-system-input-name tep-nagr-system-no-label"
                    :meta='meta.metaScheme.fieldMeta'
                    :server-data='userData'
                />
            </div>
            <div v-if='props.meta.metaScheme.showKis || props.meta.metaScheme.showKpd || meta.metaScheme.checkBox'
                 class='tep-nagr-system-input'>
                <template>
                    <div v-if='props.meta.metaScheme.showKis'>
                        <dx-button
                            style="width: 60px"
                            @click="clickKic"
                            :disabled='!userData[meta.metaScheme.fieldMeta.fieldNameText]'
                            text='Кис'
                        ></dx-button>
                    </div>
                    <div v-else style="flex: 0 0 60px"></div>
                </template>
                <div v-if='props.meta.metaScheme.showKpd' class='tep-nagr-system-input tep-nagr-system-no-label margin-left'>
                    <ai-form-number-box
                        style="width: 90px"
                        :meta='meta.metaScheme.kpdMeta'
                        :server-data='userData'
                        :callbacks='{ userDataChanged: changeKpd }'
                    ></ai-form-number-box>
                    <div style="white-space: nowrap;">[ % ]</div>
                </div>
                <div v-if='meta.metaScheme.checkBox' class="tep-nagr-system-checkbox">
                    <ai-form-check-box
                        :meta="meta.metaScheme.checkBox"
                        :callbacks='{ userDataChanged: changeCheckbox }'
                    ></ai-form-check-box>
                </div>
            </div>
        </div>
       <dx-popup
            ref="popupRef"
            height="95%"
            :title="titlePopup"
            :drag-enabled="true"
            :hide-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :visible="popupVisible"
            @hiding='onNsiClose'
       >
            <component
                :is="props.meta.metaScheme.popupData?.view"
                ref='nsiRef'
                :from-card='true'
                @choose-nsi="onChooseNsi"
                :class="props.meta.metaScheme.popupData?.view"
            />
       </dx-popup>
    </div>
</template>
<script>
export default {
    name: 'tep-nagr-system',
};
</script>

<script setup>
import { DxButton, DxPopup } from 'devextreme-vue';
import { computed, inject, onMounted, ref } from 'vue';
import tepService from '@/service/tep-service';
import { dxUiNotify } from '@/utils/dx-helper';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
import AiFormNumberBox from '@/components/card-component/ai-form-number-box.vue';
import AiFormTextBoxReadonly from '@/components/card-component/ai-form-text-box-readonly.vue';
import AiFormCheckBox from '@/components/card-component/ai-form-check-box.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {
        },
    },
    serverData: {
        type: Object,
        default: () => {
        },
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');
const currentValue = ref({});
const popupRef = ref(null);
const titlePopup = ref('');
const nameCurrentView = ref('');
const nsiRef = ref(null);

onMounted(() => {
    currentValue.value = userData?.value;
});

const popupVisible = computed(() => {
    return props.meta.metaScheme.popupData?.view === nameCurrentView?.value;
});

const changeCheckbox = () => {
    const checkbox = props.meta.metaScheme.checkBox.fieldNameText;
    if( userData?.value[checkbox] !== props.serverData[checkbox]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
};

const changeKpd = () => {
    const kpd = props.meta.metaScheme.kpdMeta.fieldNameText;
    if( userData?.value[kpd] !== props.serverData[kpd]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
}

const openNsi = async () => {
    let titleBasic = 'Схема присоединения тепловых нагрузок';
    const titleMain = props.meta.metaScheme.popupData?.title ? props.meta.metaScheme.popupData?.title : '';
    titlePopup.value = `${titleBasic} ${titleMain}`;
    const keySelectTree = userData?.value[props.meta.metaScheme.fieldMeta?.fieldNameId];
    const keySelectGrid = userData?.value[props.meta.metaScheme.fieldMeta?.gridId];
    if (typeof nsiRef.value?.onStart === 'function') await  nsiRef.value?.onStart(keySelectTree, keySelectGrid);
    await setTimeout(() => {
        nameCurrentView.value = props.meta.metaScheme.popupData?.view;
    }, 300)

};

const onNsiClose = (e) => {
    if (popupVisible.value) {
        if (typeof nsiRef.value?.onStart === 'function') {
            e.cancel = true;
            nsiRef.value?.beforeNsiClose();
        } else {
            onChooseNsi();
        }
    }
};

const onChooseNsi = async (nsiChoiceItem, isNsiChoice, selectedNsiGridKod) => {
    if (!isNsiChoice) {
        nameCurrentView.value = '';
        popupRef.value?.instance.hide();
        return;
    }
    const viewsArr = ['kod_sxp_sop', 'kod_sxp_swp', 'kod_sxp_stp', 'kod_sxp_gwp', 'kod_sxp_so', 'kod_sxp_sw', 'kod_sxp_gw'];
    if( nsiChoiceItem && Object.keys(nsiChoiceItem).length) {
        const typeKey = Object.keys(nsiChoiceItem).find(key => viewsArr.includes(key));
        let fullName = '';
        fullName = await tepService.getCardVidSxName(
            {
                kod: nsiChoiceItem[typeKey],
                fieldName: typeKey.replace('kod_sxp_', ''),
            }
        );
        let nameInput = fullName ? fullName : nsiChoiceItem.name;
        if(typeKey) {
            switch(typeKey) {
                case 'kod_sxp_sop':
                    userData.value.kod_sxp_sop = nsiChoiceItem.kod_sxp_sop;
                    userData.value.kpd_so = nsiChoiceItem.kpd;
                    userData.value.sxp_so = nameInput;
                    break;

                case 'kod_sxp_swp':
                    userData.value.kod_sxp_swp = nsiChoiceItem.kod_sxp_swp;
                    userData.value.kpd_sw = nsiChoiceItem.kpd;
                    userData.value.sxp_sw = nameInput;
                    break;
                case 'kod_sxp_stp':
                    userData.value.kod_sxp_stp = nsiChoiceItem.kod_sxp_stp;
                    userData.value.kpd_st = nsiChoiceItem.kpd;
                    userData.value.sxp_st = nameInput;
                    break;

                case 'kod_sxp_gwp':
                    userData.value.kod_sxp_gwp = nsiChoiceItem.kod_sxp_gwp;
                    userData.value.kpd_gw = nsiChoiceItem.kpd;
                    userData.value.sxp_gw = nameInput;
                    break;
                case 'kod_sxp_so':
                    userData.value.kod_sxp_so = nsiChoiceItem.kod_sxp_so;
                    userData.value.kod_sxp_so_name = nameInput;
                    userData.value.kod_tso = selectedNsiGridKod;
                    await getTempData('kod_sxp_so', selectedNsiGridKod);
                    break;
                case 'kod_sxp_sw':
                    userData.value.kod_sxp_sw = nsiChoiceItem.kod_sxp_sw;
                    userData.value.kod_sxp_sw_name = nameInput;
                    userData.value.kod_tsw = selectedNsiGridKod;
                    await getTempData('kod_sxp_sw', selectedNsiGridKod);
                    break;
                case 'kod_sxp_gw':
                    userData.value.kod_sxp_gw = nsiChoiceItem.kod_sxp_gw;
                    userData.value.kod_sxp_gw_name = nameInput;
                    break;
                default:

                    break;
            }
        }
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
    nameCurrentView.value = '';
    popupRef.value?.instance.hide();
};

const getTempData = async (tip_tn, kod_tgr) => {
    const data = await tepService.getSxTempData(tip_tn, kod_tgr);
    for( const key in data) {
        if(data[key] !== 'NaN') {
            userData.value[key] = data[key]
        }
    }
}

const deleteScheme = async () => {
    const result = await AiCustomConfirmDialog('Удалить выбранную схему подключения?', 'Удаление');
    if(result === 0 || result === -1) return;
    const nameText = props.meta.metaScheme.fieldMeta.fieldNameText;
    if(nameText) {
        switch(nameText) {
            case 'sxp_so':
                userData.value.kod_sxp_sop = null;
                userData.value.kpd_so = '';
                userData.value.sxp_so =null;
                break;

            case 'sxp_sw':
                userData.value.kod_sxp_swp = null;
                userData.value.kpd_sw = '';
                userData.value.sxp_sw = null;
                break;
            case 'sxp_st':
                userData.value.kod_sxp_stp = null;
                userData.value.kpd_st = '';
                userData.value.sxp_st = null;
                break;

            case 'sxp_gw':
                userData.value.kod_sxp_gwp = null;
                userData.value.kpd_gw = '';
                userData.value.sxp_gw = null;
                break;
            case 'kod_sxp_so_name':
                userData.value.kod_sxp_so = null;
                userData.value.kod_sxp_so_name = null;
                userData.value.kod_tso = null;
                userData.value.kod_tgr_so = null;
                userData.value.kod_tgr_so2 = null;
                userData.value.t1_so = null;
                userData.value.t2_so = null;
                userData.value.t1_sovk = null;
                userData.value.t2_sovk = null;
                userData.value.t1_gwm = props.serverData.t1_gwm;
                userData.value.t2_gwm = props.serverData.t2_gwm;
                userData.value.t1_gwsr = props.serverData.t1_gwsr;
                userData.value.t2_gwsr = props.serverData.t2_gwsr;

                break;
            case 'kod_sxp_sw_name':
                userData.value.kod_sxp_sw = null;
                userData.value.kod_sxp_sw_name = null;
                userData.value.kod_tsw = null;
                userData.value.kod_tgr_gw = null;
                userData.value.kod_tgr_gw2 = null;
                userData.value.t1_sw = null;
                userData.value.t2_sw = null;
                userData.value.t1_swvk = null;
                userData.value.t2_swvk = null;
                userData.value.tnv_sw = null;
                break;
            case 'kod_sxp_gw_name':
                userData.value.kod_sxp_gw = null;
                userData.value.kod_sxp_gw_name = null;
                userData.value.t1_gwm= null;
                userData.value.t2_gwm= null;
                break;
            default:

                break;
        }
    }
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
};

const clickKic = (() => {
    dxUiNotify('Функция в разработке', 'info', 3000);
})
</script>

<style scoped>
    .tep-nagr-system-title {
        padding: 0 0 4px;
    }
    .tep-nagr-system-container {
        display: grid;
        gap: 16px;
        //grid-template-columns: 1fr auto;
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
    .tep-nagr-system-grid {
        display: grid;
        gap: 8px;
        grid-template-columns: 32px 32px 1fr;
        grid-area: span 1 / span 4 / auto / auto;
    }
    .tep-nagr-system-input-name {
        max-width: 800px;
    }
    .tep-nagr-system-input {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .tep-nagr-system-no-label :deep(.dx-field-label) {
        display: none;
    }
    .tep-nagr-system-checkbox :deep(.dx-field) {
        padding: 0;
    }
    .margin-left {
        margin-left: auto;
    }
</style>
